export default "__VITE_ASSET__f93a06f5__"